import React from "react";

import { Table } from 'reactstrap';

function PrivacyPolicy() {
    return (
        <>
            <div
                className="page-header section-dark"
                style={{
                    backgroundColor: "#4d4d4d",
                }}/>

            <style>
                {".page-header {height: 80px; min-height: unset}"}
            </style>

            <div className="Privacy-Page">
                <h1>Política de Privacidad y Protección de Datos.</h1>
                <p>
                    Outsourcing Ingeniería de Procesos, conforme a la legislación vigente en materia de
                    Protección de Datos de Carácter Personal, pone en conocimiento de los usuarios de la página web 
                    <a href="http://www.oiprocesos.com"> www.oiprocesos.com</a>
                    (en adelante, la Página), la Política de Privacidad y Protección de Datos que aplicará en el tratamiento de los
                    datos personales que el Usuario facilite voluntariamente al acceder a su web.
                </p>

                <p>
                    El Usuario, al proporcionar a Outsourcing Ingeniería de Procesos sus datos de carácter personal a través de los formularios electrónicos de la Web,
                    apartado de contacto y en su caso, a través de la marcación de la correspondiente casilla de
                    aceptación, consiente expresamente que Outsourcing Ingeniería de Procesos pueda tratar esos datos en los términos de esta cláusula de Política de
                    Privacidad y Protección de Datos y para los fines aquí expresados.
                </p>
                <p>
                    Outsourcing Ingeniería de Procesos pone en conocimiento de los usuarios de la Página, que sus datos de carácter personal sólo podrán obtenerse para
                    su tratamiento cuando sean adecuados, pertinentes y no excesivos en relación con el ámbito y las finalidades determinadas,
                    explícitas y legítimas para las que se hayan obtenido. Serán suprimidos cuando hayan dejado de ser necesarios o pertinentes
                    para dicha finalidad o cuando lo solicite el titular en el ejercicio de su derecho de supresión.
                </p>
                <p>
                    Outsourcing Ingeniería de Procesos manifiesta su compromiso de cumplir con la legislación vigente en cada momento en materia de protección de datos.
                </p>
                <p>
                    Los datos personales facilitados serán tratados por la compañia y se utilizarán de acuerdo con la siguiente información.
                </p>

                <h2>¿Qué datos de carácter personal recabamos y para qué los utilizamos?</h2>

                <p>- Datos recabados de manera directa: por la cumplimentación voluntaria del formulario de contacto e interacción en nuestras Redes sociales. </p>
                <p>- Datos recabados de manera indirecta mediante el uso de cookies: para estadísticas y para analizar el uso que se realiza de nuestra Página. </p>
                <p>En la tabla que le mostramos a continuación encontrará información más detallada sobre el tratamiento de sus datos de carácter personal,
                    incluyéndose los siguientes epígrafes:</p>
                <p>- Finalidades principales: Se identifica con qué finalidad necesitamos recoger sus datos, es decir, por qué tratamos su información.</p>
                <p>- Legitimación: Se detalla el motivo que nos habilita para poder tratar sus datos.</p>
                <p>- Plazos de conservación: Se identifica el plazo concreto de conservación o los criterios que determinan dicho periodo.</p>
                <p>- Destinatarios: Identificamos, en su caso, con quién compartiremos sus datos de forma legítima.</p>
                <p>- Derechos de los interesados: Le informamos sobre los derechos que le asisten como interesado en el tratamiento de sus datos de carácter personal.</p>

                <h2 className="Head-Table">Información sobre protección de datos de carácter personal</h2>

                <Table striped>

                    <tbody>
                        <tr className="Table-Flex">
                            <th scope="row">Responsable del Tratamiento</th>
                            <td>Outsourcing Ingeniería de Procesos, S.A 
                            Domicilio en Parque Empresarial San Fernando Avda. de Castilla, 2
                            28830 San Fernando de Henares (Madrid).
                            CIF B-88396734
                            Teléfono: (+34) 91 740 72 50
                            Contacto: protecciondpd@oiprocesos.com
                            </td>

                        </tr>
                        <tr className="Table-Flex">
                            <th scope="row">Finalidades </th>
                            <td>
                                - <b>Formulario Contacto:</b> atender la solicitud de información demandada a través del formulario de contacto u otros formularios habilitados.
                                <br/>
                                - <b>Cookies:</b> mantener el login de usuario registrado y proporcionar estadísticas asociadas al uso de la Página.
                                <br />
                                - <b>Envío y recepción de CV:</b> gestión de procesos de selección de personal que se encuentren habilitados o puedan habilitarse en nuestra empresa a través de la plataforma EPreselect, en la que deberá registrarse el usuario.
                                <br />
                                - <b>Envíos comerciales:</b> los datos de contacto de correo electrónico del Usuario, podrán ser utilizados para remitirle anuncios y otras comunicaciones comerciales sobre nuestros productos y/o servicios, siempre que ud. lo haya autorizado expresamente con la marcación de la correspondiente casilla de aceptación.
                                <br />
                                - <b>Canal de denuncias:</b> gestionar las comunicaciones planteadas que nos envía a través del canal habilitado específicamente para ello, así como responder de la mejor manera posible a la comunicación que nos plantea.
                                <br />
                                - Los datos podrán ser usados para <b>detectar e investigar fraudes</b>, así como otras actividades ilegales y quebrantamientos potenciales de nuestras Políticas de Privacidad y/o Condiciones de Uso
                            </td>
                        </tr>
                        <tr className="Table-Flex">
                            <th scope="row">Legitimación‌ ‌y‌ ‌conservación‌</th>
                            <td>
                                La base para el tratamiento de los datos es el consentimiento prestado por el usuario al marcar la/s casilla/s de aceptación.
                                <br />
                                El tratamiento con fines de gestionar las denuncias comunicadas, se encuentra legitimado está amparado en el interés público esencial. 
                                <br />
                                El tratamiento con fines de detección e investigación de fraudes está amparado en el cumplimiento de obligación legales del Responsable.
                                <br />
                                Los campos del formulario de contacto marcados con un asterisco (*) tienen la consideración de campos necesarios para gestionar el objeto de este. De no facilitarse, no será posible atender su solicitud.
                                <br />
                                Consulte nuestra Política de Cookies para obtener información sobre las cookies que utiliza nuestra web.
                            </td>
                        </tr>
                        <tr className="Table-Flex">
                            <th scope="row"></th>
                            <td>
                                - Los datos de contacto se conservarán durante el tiempo necesario para atender su consulta y mientras no se solicite su supresión.
                                <br />
                                - Los datos relativos a información de curriculum se conservarán durante un plazo máximo de dos años.
                                <br />
                                - Los datos que nos comunique a través del canal de denuncias, siempre que den curso a una investigación serán conservados por un plazo máximo de tres meses, ampliables a 3 meses adicionales, en función de la complejidad del asunto comunicado. Igualmente podrán conservarse fuera del canal, durante el plazo necesario para dar cumplimiento a las obligaciones legales y a los plazos de prescripción de las acciones que se deriven de la investigación.
                                <br />
                                - Consulte nuestra Política de Cookies para identificar la vigencia de cada cookie.
                                <br />
                                - Los datos asociados a su interacción en los perfiles corporativos de redes sociales se conservarán durante el plazo que usted habilite en dicha red social a sus publicaciones.
                            </td>
                        </tr>
                        <tr className="Table-Flex">
                            <th scope="row">Destinatarios de cesiones y transferencias internacionales</th>
                            <td>
                                No se han previsto cesiones de sus datos a terceros, excepto:
                                <br />
                                - <b>Responsables de servicios de analítica web:</b> La Página tiene habilitados los servicios de Google Analytics prestados por Google LLC, entidad ubicada en EE. UU. y adherida a la
                                Decisión de Adecuación de la Comisión, de 10 de julio de 2023, EU-USA Data Privacy Framework, que posibilita el flujo de datos personales de ciudadanos europeos a EE.UU.
                                La interacción con los usuarios por el uso de dicha herramienta implica el uso de datos de tipo analítico y técnico en relación con la Página, siempre y cuando haya aceptado
                                la habilitación de dichas cookies a través del panel de configuración.
                               
                                <br />
                                - <b>Titulares de redes sociales:</b> La interacción con los usuarios por el uso de dichos perfiles o herramientas implica la transferencia internacional de datos (de tipo analítico y técnico) a los servidores de la red social.
                                Para más información consulte el siguiente enlace: https://www.linkedin.com/legal/privacy-policy?trk=d_org_guest_company_overview_footer-privacy-policy
                                <br />
                                - <b>Titulares de redes sociales:</b> Administraciones Públicas cuando sea preceptivo por dar cumplimiento a nuestras obligaciones legales.
                            </td>

                        </tr>
                        <tr className="Table-Flex">
                            <th scope="row">Derechos de los interesados</th>
                            <td>
                                - Puede ejercitar sus derechos de acceso, rectificación, supresión, portabilidad y la limitación u oposición, así como retirar el consentimiento prestado dirigiéndose por escrito a la dirección indicada anteriormente.
                                <br />
                                - Los interesados tienen derecho a reclamar ante la Autoridad de Control (Agencia Española de Protección de Datos: www.aepd.es).
                            </td>
                        </tr>
                    </tbody>
                </Table>

                <p>
                    El usuario será el único responsable de la veracidad de los datos facilitados a la Compañía.
                </p>
                <p>
                    La Compañía adopta las medidas de índole técnica y organizativa necesarias para garantizar la seguridad de los datos de carácter personal contenidos en los mismos y para evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, 
                    la naturaleza de los datos y los riesgos a los que están expuestos. 
                </p>
                <p>
                    La página dispone del Certificado SSL (Secure Socket Layer), con la finalidad de garantizar la seguridad en la transmisión de datos entre su navegador y nuestra Página.
                </p>
                <p>
                    El servidor seguro establece una conexión de modo que la información se transmite cifrada, que aseguran que solo sea inteligible para el dispositivo del usuario y el de la Página. De este modo, al utilizar el protocolo SSL se garantiza:
                </p>
                <p>
                    Que el usuario está comunicando sus datos al centro servidor de la Página y no a cualquier otro.
                </p>
                <p>
                    Que entre el usuario y la Página los datos se transmiten cifrados, evitando su posible lectura o manipulación por terceros.
                </p>
                <p>
                    Para verificar que se encuentra en un entorno seguro, el Cliente debe revisar que la dirección de la Página de verificación comience por https://
                </p>
                <p>
                    También puede identificar la página como segura cuando aparezca el icono de un candado en la barra de dirección de su navegador.
                </p>
                <p>
                    Por último, también puede verificar la presencia del certificado SSL comprobando las propiedades de la Página en su navegador, para lo cual deberá consultar las características del mismo.
                </p>
                <p>
                    Cualquier cambio realizado en la Política de Privacidad y en las prácticas de administración de la información se refleja de forma oportuna, pudiendo la Compañía agregar, modificar o eliminar dicha política de privacidad cuando lo estime necesario. 
                </p>
                <p>
                    En ningún caso la Compañía modificará las políticas ni prácticas para hacerlas menos eficaces en la protección de los datos personales de nuestros clientes almacenados anteriormente, sin el consentimiento previo de los clientes afectados.
                </p>
                <p>Última actualización: 11 de enero de 2024.</p>
            </div>
        </>
    )
}

export default PrivacyPolicy;